export interface BasicJwt {
  exp: number;
  sub: string;
  iat: number;
}

export interface IJWTPayload extends BasicJwt {
  email: string;
  firstName: string;
  lastName: string;
  sid: string;
  jti: string;
  nonce: string;
  aud: string[];
  accountingOrganization: string;
  rights: string;
  role: string;
  iss: string;
  mandant: string;
  nbf: number;
}

const now: number = Math.floor(Date.now() / 1000);

export const DEFAULT_JWT_PAYLOAD: IJWTPayload = {
  sub: 'd3370e03-9751-4b4d-885e-16fc859805a7',
  email: 'max.mustermann@example.com',
  firstName: 'Max',
  lastName: 'Mustermann',
  sid: '842d4a5c-5242-4cc2-a853-468caccda9d5',
  jti: '43322c0e-1b01-4672-9e01-883018cc2089',
  nonce: '6afecae4-45cb-40e5-a611-46d760615a57',
  aud: ['BasisApi', '55948e26-9738-4acf-930a-41dc20a47f18'],
  accountingOrganization: '',
  rights:
    '[1000,1002,1004,1005,1006,1007,1008,1009,1010,1011,1012,1013,1014,1015,1016,1017,1019,1020,1021,1022,1024,1025,1026,1027,1028,1030,1031,1032,1033,1035,1045,1046,1047,1049,1052,1055,1060,1063,1076,3001]',
  role: 'CmsAdmin',
  iss: 'https://shop.vertrieb-web.cluster.amcon-dev.cloud/',
  iat: now,
  mandant: 'CLIENT_ID_PLACEHOLDER',
  nbf: now,
  exp: now + 3000000,
};
